<template>
  <v-autocomplete
    v-model="value"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    color="primary"
    hide-selected
    item-text="text"
    item-value="id"
    placeholder="Escriba SKU o nombre del artículo..."
    label="Buscar Material"
    return-object
    outlined
    clearable
    dense
    cache-items
    @input="updateValue"
    @change="cambio"
    hide-details
    :disabled="disabled"
    class="modern-autocomplete"
    prepend-inner-icon="fas fa-search"
  >
    <template v-slot:selection="{ item }">
      <div class="d-flex align-center py-1">
        <v-chip x-small label color="primary" class="font-weight-black mr-2">{{item.sku}}</v-chip>
        <span class="body-2 font-weight-medium grey--text text--darken-3">{{item.name}}</span>
      </div>
    </template>
    
    <template v-slot:item="data">
      <div class="d-flex align-center py-2 w-100">
        <v-avatar size="32" color="grey lighten-4" class="mr-3">
          <v-icon x-small color="grey darken-1">fas fa-tag</v-icon>
        </v-avatar>
        <div class="flex-grow-1 overflow-hidden">
          <div class="body-2 font-weight-black grey--text text--darken-4 text-truncate">{{data.item.name}}</div>
          <div class="caption primary--text font-weight-black">{{data.item.sku}}</div>
        </div>
        <v-icon x-small color="grey lighten-1">fas fa-chevron-right</v-icon>
      </div>
    </template>

    <template v-slot:no-data>
      <div class="pa-4 text-center">
        <v-icon small color="grey lighten-1" class="mb-2">fas fa-search</v-icon>
        <div class="caption grey--text font-weight-bold">No se encontraron artículos</div>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import {fetchArticles} from '@/api/stocks'
import notifications from '@/utils/notifications'

  export default {
    name:'ArticleComplete',
    data: () => ({
      descriptionLimit: 60,
      customers: [],
      isLoading: false,
      model: null,
      search:null,
      select:null,
      items: [],
      timer:'',
    }),
    props:['value','disabled','article_name'],
    methods:{
      updateValue(){
        this.value ? this.$emit('input',this.value) : this.$emit('input','')
      },
      cleared(){
        this.$emit('input','')
      },
      cambio(){
        console.log('cambio en el value')
      },
      async querySelections (v) {
        this.isLoading = true
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          const query=`ordering=-sku&search=${v}&page=1&&page_size=20&status=true`
          await fetchArticles(query)
          .then((res)=>{
            const data = res.results.map(i=>{
              i.text=i.sku+i.name
              return i
            })
            this.items=data
            this.isLoading=false
          })
        }, 1000); 
      },
    },
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
      article_name(val){
        console.log(val)
        if(val) this.search=val
      }
    },
    
    
  }
</script>